import { useState, type FormEvent } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { AuthCard } from "./AuthCard";
import { useSetup } from "./session";

const MIN_LENGTH = 12;

/** First run of the desktop app: the user creates the administrator account. */
export function SetupPage() {
  const setup = useSetup();
  const [username, setUsername] = useState("admin");
  const [displayName, setDisplayName] = useState("Administrator");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const mismatch = confirm.length > 0 && password !== confirm;

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (password !== confirm) return;
    setup.mutate({ username, display_name: displayName, password });
  };

  return (
    <AuthCard
      title="Welcome to AVGV"
      subtitle="Create the administrator account. You'll use it to sign in and to add other users."
      onSubmit={submit}
    >
      <TextField
        label="Username"
        autoComplete="username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
      />
      <TextField
        label="Display name"
        autoComplete="name"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
        required
      />
      <TextField
        label="Password"
        helperText={`At least ${MIN_LENGTH} characters`}
        type="password"
        autoComplete="new-password"
        slotProps={{ htmlInput: { minLength: MIN_LENGTH } }}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        autoFocus
      />
      <TextField
        label="Confirm password"
        type="password"
        autoComplete="new-password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        error={mismatch}
        helperText={mismatch ? "Passwords do not match." : undefined}
        required
      />
      {setup.isError && <Alert severity="error">{setup.error.message}</Alert>}
      <Button type="submit" variant="contained" size="large" disabled={setup.isPending || mismatch}>
        Create account
      </Button>
    </AuthCard>
  );
}
